import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumOrganizationPlanning({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M204 516C204 535.882 187.882 552 168 552C148.118 552 132 535.882 132 516C132 496.118 148.118 480 168 480C187.882 480 204 496.118 204 516Z"
        fill="#57D7D9"
      />
      <path
        d="M372 516C372 535.882 355.882 552 336 552C316.118 552 300 535.882 300 516C300 496.118 316.118 480 336 480C355.882 480 372 496.118 372 516Z"
        fill="#57D7D9"
      />
      <path
        d="M156 384C156 377.373 161.373 372 168 372H180V444C180 450.627 174.627 456 168 456C161.373 456 156 450.627 156 444V384Z"
        fill="white"
      />
      <path d="M324 372V396H176V372H324Z" fill="white" />
      <path
        d="M396 372C402.627 372 408 377.373 408 384C408 390.627 402.627 396 396 396H384C377.373 396 372 390.627 372 384C372 377.373 377.373 372 384 372H396Z"
        fill="white"
      />
      <path
        d="M456 372C462.627 372 468 377.373 468 384C468 390.627 462.627 396 456 396H444C437.373 396 432 390.627 432 384C432 377.373 437.373 372 444 372H456Z"
        fill="white"
      />
      <path
        d="M504 372C510.627 372 516 377.373 516 384C516 390.627 510.627 396 504 396C497.373 396 492 390.627 492 384C492 377.373 497.373 372 504 372Z"
        fill="white"
      />
      <path
        d="M504 480C523.882 480 540 496.118 540 516C540 535.882 523.882 552 504 552C484.118 552 468 535.882 468 516C468 496.118 484.118 480 504 480Z"
        fill="white"
      />
      <path
        d="M504 420C510.627 420 516 425.373 516 432V444C516 450.627 510.627 456 504 456C497.373 456 492 450.627 492 444V432C492 425.373 497.373 420 504 420Z"
        fill="white"
      />
      <path
        d="M324 324C324 317.373 329.373 312 336 312C342.627 312 348 317.373 348 324V444C348 450.627 342.627 456 336 456C329.373 456 324 450.627 324 444V324Z"
        fill="white"
      />
      <path
        d="M240 264C240 237.49 261.49 216 288 216H384C410.51 216 432 237.49 432 264V280C432 284.418 428.418 288 424 288H248C243.582 288 240 284.418 240 280V264Z"
        fill="#57D7D9"
      />
      <path
        d="M384 144C384 170.51 362.51 192 336 192C309.49 192 288 170.51 288 144C288 117.49 309.49 96 336 96C362.51 96 384 117.49 384 144Z"
        fill="#57D7D9"
      />
      <path
        d="M544 252C548.418 252 552.089 248.375 551.115 244.066C550.147 239.782 548.398 235.689 545.933 231.999C541.977 226.079 536.355 221.465 529.777 218.74C523.198 216.016 515.96 215.303 508.977 216.692C501.993 218.081 495.579 221.509 490.544 226.544C485.509 231.579 482.081 237.993 480.692 244.977C479.303 251.96 480.016 259.198 482.74 265.777C485.465 272.355 490.079 277.977 495.999 281.933C499.689 284.398 503.782 286.147 508.066 287.115C512.375 288.089 516 284.418 516 280V260C516 255.582 519.582 252 524 252H544Z"
        fill="#57D7D9"
      />
      <path
        d="M557.092 339.073C551.401 324.89 539.445 295.067 529.893 271.093C528.593 267.83 531.834 264.607 535.096 265.912L603.038 293.089C606.243 294.371 606.429 298.837 603.342 300.38L578.56 312.771C577.786 313.158 577.158 313.786 576.771 314.56L564.373 339.356C562.831 342.441 558.376 342.274 557.092 339.073Z"
        fill="white"
      />
    </svg>
  );
}
